import { useNewModuleStore } from "../stores/newModuleStore";

export function splitContentList(data: any[]) {
  const { main, summary, knowmore } = data.reduce(
    (acc: any, content: any) => {
      if (content.type === 'main') {
        acc.main.push(content);
      } else if (content.type === 'knowmore') {
        acc.knowmore.push(content);
      } else {
        acc.summary.push(content);
      }

      return acc;
    },
    { main: [], summary: [], knowmore: [] }
  );

  const list = [...main, ...summary, ...knowmore];

  return list;
}

export const getModuleLabel = (module: string) => {
  const modules = useNewModuleStore.getState().modules;

  const moduleLabel = modules.find(it => it.slug === module)?.title;

  if(!moduleLabel) {
    return module.replaceAll('-', ' ').replace(/\b\w/g, l => l.toUpperCase()) || '';
  }

  return moduleLabel;
}

export const getModuleDescription = (module: string) => {
  const modules = useNewModuleStore.getState().modules;

  const moduleDescription = modules.find(it => it.slug === module)?.description;

  return moduleDescription;
}